module.exports = __webpack_public_path__ + "img/criterionimg3.8add336f.png";